import { render, staticRenderFns } from "./AccessTable.vue?vue&type=template&id=1f2625ac&scoped=true"
import script from "./AccessTable.vue?vue&type=script&lang=js"
export * from "./AccessTable.vue?vue&type=script&lang=js"
import style0 from "./AccessTable.vue?vue&type=style&index=0&id=1f2625ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2625ac",
  null
  
)

export default component.exports